import { Box, Stack, Typography } from "@mui/material";
import { APP_PAGE_SIZE_MEDIUM } from "app/appConstants";
import { MprcChipChoice, MprcContainer, MprcRequestErrorReport, MprcSpinnerIndicator } from "components";
import { UserItemDtoPaginatedList, UserPanelPersonalInterestDto, UserPanelPersonalInterestDtoPaginatedList } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ListUsersDrawer } from "views/foundation/user/drawers/ListUsersDrawer";

interface IProps {
    viewData: UserPanelPersonalInterestDtoPaginatedList;
    onGetData: (pageSize: number) => Promise<boolean>;
}

/**
 * Painel lateral para interesses pessoais do usuário.
 * @param props
 */
export const PanelUserPersonalInterest: React.FC<IProps> = (props) => {
    const { viewData, onGetData } = props;

    const api = useCoreApi();
    const { t } = useTranslation("knowledge");

    const [dialog, setDialog] = useState<any>();
    const [viewError, setViewError] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const [showAll, setShowAll] = useState<boolean>(false);

    const handleClick = (tag: UserPanelPersonalInterestDto) => {
        setDialog(
            <ListUsersDrawer
                title={t("Feed.Panels.UserPersonalInterest.UsersSameInterestTitle")}
                subtitle={tag.name}
                onClose={() => setDialog(null)}
                onGetData={({ searchText, pageNumber, pageSize }, signal) =>
                    new Promise<UserItemDtoPaginatedList>((resolve, reject) => {
                        api.v1.knowledgeFeed.getFeedPanelUsersSameInterestTag({ tagId: tag.tagId, searchText, pageNumber, pageSize }, { signal })
                            .then(result => resolve(result.data))
                            .catch(e => reject(e));
                    })
                }
            />
        );
    };

    ///
    const handleSeeAll = () => {
        setShowAll(!showAll);
        setLoading(true);
    };

    ////////////////////////////////////////////////////////////////////////////
    /// EFFECT
    ////////////////////////////////////////////////////////////////////////////

    // Ao carregar os dados
    useEffect(() => {
        async function getData() {
            try {
                onGetData(showAll ? 0 : APP_PAGE_SIZE_MEDIUM);
            }
            catch (e) {
                setViewError(e);
            }
            finally {
                setLoading(false);
            }
        }

        if (loading) getData();

    }, [loading]);

    ////////////////////////////////////////////////////////////////////////////
    /// Render
    ////////////////////////////////////////////////////////////////////////////

    return viewError
        ? <MprcRequestErrorReport error={viewError} />
        : viewData.items.length > 0
            ? (
                <>
                    <MprcContainer margin="dense">
                        <Typography variant="h3">{t("Feed.Panels.UserPersonalInterest.Title")}</Typography>
                    </MprcContainer>

                    {dialog}

                    {
                        loading
                            ? <MprcSpinnerIndicator />
                            : (
                                <>
                                    <Stack direction="row" justifyContent="flex-start" alignContent="flex-start" flexWrap="wrap">
                                        {viewData?.items?.map(item =>
                                            <MprcChipChoice
                                                label={item.name}
                                                key={item.tagId}
                                                selected={false}
                                                maxWidth={150}
                                                onClick={() => handleClick(item)}
                                            />
                                        )}
                                    </Stack>
                                    {
                                        viewData.totalRows > APP_PAGE_SIZE_MEDIUM &&
                                        <Box marginTop={1}>
                                            <Typography
                                                variant="captionHeader"
                                                component="a"
                                                onClick={() => handleSeeAll()}
                                            >
                                                <b>{showAll ? t("Feed.Panels.UserPersonalInterest.SeeLessText") : t("Feed.Panels.UserPersonalInterest.SeeAllText")}</b>
                                            </Typography>
                                        </Box>
                                    }
                                </>
                            )
                    }
                </>
            )
            : null;
};
